<fw-dialog width='small' [title]="'profile.edit.title' | translate">
  <fw-dialog-content>
    <fw-alert
      *ngIf="profile.disabled"
      icon="user-delete-cross"
      [title]="'profile.edit.deactivatedTitle' | translate"
      [description]="'profile.edit.deactivatedDesc' | translate"
      severity="error">
    </fw-alert>
    <fw-alert
      *ngIf="centralEnabled"
      icon="user-setting-gear"
      [title]="'profile.edit.centralManagedTitle' | translate | interpolate:centralOrg"
      severity="info">
        {{ 'profile.edit.centralManagedDesc' | translate }}
        <fw-button (click)="navigateToCentralManagement()">
         {{ 'profile.edit.manageUsers' | translate }}
        </fw-button>
    </fw-alert>
    <div>
      <div class="avatar"
        (click)="editAvatar()"
        *ngIf='!centralEnabled'
        test-id='profile-edit-edit-photo'>
        <fw-avatar
          *ngIf="profile"
          size='x-large'
          variant="circular"
          [appUser]="profile">
        </fw-avatar>
        <a><p>{{ 'profile.edit.editPhoto' | translate }}</p></a>
      </div>

      <form [formGroup]="userInfo">
        <fw-grid>
          <fw-grid-item [cols]='6'>
            <fw-wrapped-input
              title="First Name"
              [errorText]="getErrorMessage('firstname') | async">
              <fw-text-input
                formControlName='firstname'
                test-id='profile-edit-firstname'
                [error]='userInfo.controls.firstname.invalid'
              ></fw-text-input>
            </fw-wrapped-input>
          </fw-grid-item>

          <fw-grid-item [cols]='6'>
            <fw-wrapped-input
              title="Last Name"
              [errorText]="getErrorMessage('lastname') | async">
              <fw-text-input
                formControlName='lastname'
                test-id='profile-edit-lastname'
                [error]='userInfo.controls.lastname.invalid'
              ></fw-text-input>
            </fw-wrapped-input>
          </fw-grid-item>

          <fw-grid-item [cols]="data.manageOtherUser ? 6 : 12">
            <fw-wrapped-input
              title="Email"
              [errorText]="getErrorMessage('email') | async">
              <fw-text-input
                formControlName='email'
                type='email'
                test-id='profile-edit-email'
                [error]='userInfo.controls.email.invalid'
              ></fw-text-input>
            </fw-wrapped-input>
          </fw-grid-item>

          <fw-grid-item *ngIf="data.manageOtherUser" [cols]='6'>
            <fw-wrapped-input [title]="centralEnabled ? 'Organizaion Role' : 'Role'" >
              <fw-select
                formControlName="role"
                width="100%"
                test-id='profile-edit-role'>
                <fw-menu-item [value]="SiteRole.User" title="User"></fw-menu-item>
                <fw-menu-item [value]="SiteRole.Developer" title="Developer"></fw-menu-item>
                <fw-menu-item [value]="SiteRole.SiteAdmin" title="Site Admin"></fw-menu-item>
              </fw-select>
            </fw-wrapped-input>
          </fw-grid-item>

          <fw-grid-item *ngIf="data.manageOtherUser" [cols]='12'>
            <fw-wrapped-input *featureIf="['ldap_sync']" title="LDAP Sync ID" helperText="Cannot be changed once set">
              <fw-text-input formControlName="ldap_sync_id"/>
            </fw-wrapped-input>
          </fw-grid-item>
        </fw-grid>
      </form>
    </div>
  </fw-dialog-content>
  <fw-dialog-actions>
    <div *ngIf="data.manageOtherUser && !centralEnabled" style="flex: 1">
      <fw-button
        *ngIf="!profile?.disabled"
        leftIcon="user-delete-cross"
        test-id="profile-edit-deactivate-button"
        (click)="deactivateUser()"
        variant="outline"
        color="danger">
        {{ 'profile.edit.deactivateUser' | translate }}
      </fw-button>
      <fw-button
        *ngIf="profile?.disabled"
        leftIcon="rotate-refresh"
        test-id="profile-edit-reactivate-button"
        (click)="reactivateUser()"
        variant="outline"
        color="danger">
        {{ 'profile.edit.reactivateUser' | translate }}
      </fw-button>
    </div>
    <fw-button test-id="profile-edit-cancel-button" (click)="close()" variant="outline">
      {{ 'common.actions.cancel' | translate }}
    </fw-button>
    <fw-button test-id="profile-edit-save-button" (click)="saveUserInfo()" variant="solid"
      [disabled]="userInfo.invalid || centralEnabled">
      {{ 'common.actions.save' | translate }}
    </fw-button>
  </fw-dialog-actions>
</fw-dialog>

